"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = require("./List.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var renderList = {
  default: function _default(props) {
    return _react.default.createElement(_List.StyledList, props, props.children);
  },
  pill: function pill(props) {
    return _react.default.createElement(_List.StyledPillOptionsList, props, props.children);
  },
  article: function article(props) {
    return _react.default.createElement(_List.StyledArticleList, props, props.children);
  }
};

var List = function List(props) {
  var styleFor = props.styleFor;
  return renderList[styleFor](props);
};
/**
 * Definition of default values for component props
 */


exports.List = List;
List.defaultProps = {
  children: undefined,
  width: '100%',
  disabled: false,
  className: undefined,
  id: undefined,
  styleFor: 'default'
};
/**
 * Definition of types for component props
 */

List.propTypes = {
  /** Collection of items in the list. Must be a collection of ListItems */
  children: _propTypes.default.node,

  /** The CSS width property for the list */
  width: _propTypes.default.string,

  /** Wheather the list is disabled or not. If 'true', the items cannot be clicked */
  disabled: _propTypes.default.bool,

  /** Component ClassName */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string,
  styleFor: _propTypes.default.oneOf(['default', 'pill', 'article'])
};